import React from 'react'

import Navbar from './Navbar'
import chicken from '../chicken.jpg'
import zanzibar from '../zanzibar.jpg'
import Footer from './Footer'



function Home() {
  return (
    <div className='general'>
        <Navbar />
        <div className='main'>
            <div className='main-column'>
                <div className='columnA'>
                    <img src={chicken} alt='prepared Chicken' className='chicken photo' />
                </div>
                <div className='columnB'>
                    <h3>Welcome to Briggs Flavours - Your Culinary Destination</h3>
                    <p>Eat Briggs Flavours, we celebrate the artistry of food and the joy of travel. 
                        Whether you're a seasoned foodie or a passionate traveler, our platform is your 
                        ultimate destination for culinary inspiration, travel adventures, and everything 
                        in between.</p>
                    <h3>Explore Our Blog:</h3>
                    <p>Dive into our rich blog content curated specially for food and travel enthusiasts like you. 
                        From tantalizing recipes to hidden gems in culinary destinations around the globe, our blog 
                        is your go-to source for culinary adventures and travel information. <a href="/blog" target="_blank">Explore Now</a></p>
                    
                </div>
                <div className='columnC'>
                    <img src={zanzibar} alt='zanzibar resort' className='zanzibar photo' />
                </div>
            </div>
            <div className='getaway'>
                <div>
                <h3>Discover Our Cookbooks:</h3>
                    <p>Elevate your culinary skills with our collection of carefully crafted cookbooks. Whether you're a novice in the kitchen or a seasoned chef, our cookbooks offer a delightful array of recipes and cooking techniques to inspire your culinary journey. </p>
                    <p><a href="/food" target="_blank">Browse Now</a></p>
                </div>
                <div>
                    <h3>Find Your Perfect Getaway:</h3>
                    <p>Planning your next culinary escapade? Look no further. Briggs Flavours provides comprehensive referrals and reviews for hotels and restaurants, ensuring that your travel experience is nothing short of extraordinary. Whether you're craving Michelin-starred dining or cozy boutique accommodations, we've got you covered. </p>
                    <p><a href="/travel" target="_blank">Explore Now</a></p>
                </div>
            </div>
            <div>
            <h3>Start Your Culinary Journey with Briggs Flavours Today!</h3>
            </div>
        </div>
        <Footer />

    </div>

  )
}

export default Home